import TextField from "./components/widgets/fields/TextField.svelte"
import DateField from "./components/widgets/fields/DateField.svelte"
import NumberField from "./components/widgets/fields/NumberField.svelte"
import SourceField from "./components/widgets/fields/SourceField.svelte"
import StatusField from "./components/widgets/fields/StatusField.svelte"
import DealerField from "./components/widgets/fields/DealerField.svelte"
import ChargeableField from "./components/widgets/fields/ChargeableField.svelte"
import OperationPositionPriceSummary from "./components/routes/operations/OperationPositionPriceSummary.svelte"
import { get } from "lodash"
import CancellationField from "./components/widgets/fields/CancellationField.svelte"
import EndCustomerName from "./components/widgets/fields/EndCustomerName.svelte"
import FollowUpListOwner from "./components/widgets/fields/FollowUpListOwner.svelte"
import DateTimeField from "./components/widgets/fields/DateTimeField.svelte"
import { get as svelteGet } from "svelte/store"
import { _ } from "svelte-i18n"
const operation1Types: OperationTableType[] = ["operation1", "operation1Bookmarks"],
    operation2Types: OperationTableType[] = ["operation2", "operation2Bookmarks"],
    operationOut1Types: OperationTableType[] = ["operationOut1", "operationOut1Bookmarks"],
    operationOut2Types: OperationTableType[] = ["operationOut2", "operationOut2Bookmarks"],
    allOperation1Types: OperationTableType[] = [...operation1Types, ...operationOut1Types],
    allOperation2Types: OperationTableType[] = [...operation2Types, ...operationOut2Types],
    allTableColumnTypes: OperationTableType[] = [...allOperation1Types, ...allOperation2Types, "cart"]

export function getTableColumn(
    _showPrices: boolean,
    operationtype: OperationTableType,
    additionalColumns: AllTableColumns[] = []
) {
    const allTableColumns: AllTableColumns[] = [
        {
            label: svelteGet(_)("tableColumns.source.label"),
            field: "source",
            sortable: true,
            component: SourceField,
            tables: allTableColumnTypes,
            align: "center",
            className: "herkunft mw-40 w-40 max-w-40 ",
            headerTooltip: svelteGet(_)("tableColumns.source.tooltip"),
            getProps(op: Operation, field) {
                return {
                    value: op.source,
                    additionalInfo: op.source == 10 && op.clerk?.name ? "(SB: " + op.clerk.name + ")" : "",
                }
            },
            columns: {
                operationOut1: {
                    getProps(op: Operation, field) {
                        return {
                            value: op.source,
                        }
                    },
                },
                cart: {
                    getProps(op: Operation, field) {
                        return {
                            value: op.source,
                        }
                    },
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "source") || "invalid"}`,
                            optional: true,
                        }
                    },
                    className: "herkunft mw-60 w-60 max-w-90",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.dealerNumber.label"),
            field: "dealerNumber",
            sortable: true,
            tables: allTableColumnTypes,
            tooltipComponent: DealerField,
            className: "mw-70 w-70 hidden1450 max-w-70",
            getTooltipProps(op: Operation, field) {
                return {
                    number: op.dealerNumber,
                    optional: true,
                }
            },
            columns: {
                operation1: {},
                operationOut1: {
                    className: "mw-70 w-70 hidden1100 max-w-70",
                },
                operation2: {},
                cart: {
                    className: "mw-100 w-100 hidden1450 max-w-90",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.releaseDate.label"),
            field: "releaseDate",
            tables: [...operation1Types, "cart"],
            sortable: true,
            component: DateField,
            className: "mw-140 w-140 max-w-140 hidden1550",
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {
                operation1: {},
                cart: {
                    className: "mw-140 w-140 hidden1300 max-w-150",
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "releaseDate") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "releaseDate")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.releaseDate.label"),
            field: "insertTime",
            tables: ["operationOut1"],
            sortable: true,
            component: DateField,
            className: "mw-140 w-140 max-w-140 hidden1550",
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {
                operationOut1: {
                    className: "mw-120 w-120 max-w-140 hidden1400",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.insertTimeOut2.label"),
            field: "insertTime",
            tables: ["operationOut2"],
            sortable: true,
            component: DateField,
            className: "mw-140 w-140 max-w-140 hidden1550",
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {
                operationOut2: {
                    className: "mw-120 w-120 max-w-140 hidden1400",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.number.labelOffer"),
            field: "number",
            tables: [...allOperation1Types, "cart"],
            sortable: true,
            columns: {
                operation1: {
                    className: "mw-90 angebotsnr  w-90 max-w-90 ",
                    getProps(row, field) {
                        return {
                            value: get(row, field),
                        }
                    },
                },
                operationOut1: {
                    className: "angebotsnr mw-90 w-90 max-w-90 ",
                    label: svelteGet(_)("tableColumns.number.labelOffer"),
                },
                cart: {
                    className: "angebotsnr mw-125 w-125  max-w-140",
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "number") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "number")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.number.labelOrder"),
            field: "number",
            tables: allOperation2Types,
            sortable: true,
            columns: {
                operation2: {
                    className: "mw-125 w-125 max-w-140 hidden660 angebotsnr",
                    getProps(row, field) {
                        return {
                            value: get(row, field),
                        }
                    },
                },
                operationOut2: {
                    className: "mw-125 w-125 max-w-140 hidden660 angebotsnr",
                    getProps(row, field) {
                        return {
                            value: get(row, field),
                        }
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.countOfPositions.label"),
            field: "countOfPositions",
            tables: [...operation1Types, ...operation2Types, "cart"],
            className: "mw-90 w-90 max-w-90 hidden1600",
            sortable: true,
            align: "center",
            columns: {
                operation1: {
                    className: "mw-90 max-w-90 w-90 hidden800",
                    component: NumberField,
                    getProps(row, field) {
                        return {
                            // stoernierte Positionen werden ausgeblendet in Angeboten anstatt gekennzeichnet wie in Aufträgen
                            value: get(row, field) - (get(row, "countOfCanceledPositions") || 0),
                            decimals: 0,
                        }
                    },
                },
                operation2: {},
                cart: {
                    component: NumberField,
                    className: "mw-100 w-100 hidden1600 max-w-120",
                    getProps(row, field) {
                        return {
                            // stoernierte Positionen werden ausgeblendet in Angeboten anstatt gekennzeichnet wie in Aufträgen
                            value: get(row, field) - (get(row, "countOfCanceledPositions") || 0),
                            decimals: 0,
                        }
                    },
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "countOfPositions") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "countOfPositions")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.status.label"),
            field: "status",
            tables: allTableColumnTypes,
            sortable: false,
            component: StatusField,
            getProps(row: Operation, field) {
                return {
                    row: row,
                }
            },
            columns: {
                operation1: {
                    className: "status max-w-100",
                    align: "center",
                },

                operation2: {
                    className: "status mw-160 max-w-160 w-160",
                },
                operationOut2: {
                    className: "status mw-160 max-w-160 w-160",
                },
                operationOut1: {
                    field: "statusSummary.created",
                    className: "status mw-90 max-w-100 w-90",
                },
                cart: {
                    field: "statusSummary.created",
                    className: "status max-w-100",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "statusSummary.created") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "statusSummary.created")
                    },
                },
            },
        },

        {
            label: svelteGet(_)("tableColumns.canceled.label"),
            field: "statusSummary.canceled",
            tables: allOperation2Types,
            sortable: true,
            component: CancellationField,
            columns: {
                operation2: {
                    className: "col_storno hidden600 w-80 max-w-90",
                    getProps(op: Operation, field) {
                        return {
                            statusSummary: op.statusSummary,
                        }
                    },
                },
                operationOut2: {
                    className: "col_storno hidden600 w-80 max-w-90",
                    getProps(op: Operation, field) {
                        return {
                            statusSummary: op.statusSummary,
                        }
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.chargeable.labelShort"),
            mobileLabel: svelteGet(_)("tableColumns.chargeable.label"),
            field: "statusSummary.chargeable",
            tables: [...operation1Types, ...operation2Types, ...operationOut2Types, "cart"],
            sortable: true,
            getProps(op: Operation, field) {
                return {
                    positions: op.positions,
                    statusSummary: op.statusSummary,
                }
            },
            component: ChargeableField,
            hide: !_showPrices,
            className: "max-w-60",
            headerTooltip: svelteGet(_)("tableColumns.chargeable.label"),
            columns: {
                operation1: {},
                operation2: {},
                cart: {
                    field: "statusSummary.chargeable",
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "statusSummary.chargeable") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "statusSummary.chargeable")
                    },
                    tooltipComponent: TextField,
                    className: "max-w-80",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.inquiryDate.label"),
            field: "inquiryDate",
            tables: [...allOperation1Types, "cart"],
            sortable: true,
            component: DateField,
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {
                operation1: {
                    className: "mw-120 w-120 hidden1480 max-w-120",
                },
                operationOut1: {
                    className: "mw-120 w-120 max-w-140 hidden1200",
                    field: "inquiryDate",
                },
                cart: {
                    field: "inquiryDate",
                    className: "mw-120 w-120 hidden1200 max-w-150",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "inquiryDate") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "inquiryDate")
                    },
                },
            },
        },

        {
            label: svelteGet(_)("tableColumns.releaseDateOrder.label"),
            field: "releaseDate",
            tables: allOperation2Types,
            sortable: true,
            component: DateField,
            columns: {
                operation2: {
                    className: "mw-140 w-140 max-w-140 hidden1900",
                    getProps(row, field) {
                        return {
                            value: get(row, field),
                        }
                    },
                },
                operationOut2: {
                    className: "mw-140 w-140 max-w-140 hidden1900",
                    getProps(row, field) {
                        return {
                            value: get(row, field),
                        }
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.endCustomerName.label"),
            field: "endCustomer.name",
            tables: [...operation1Types, ...allOperation2Types, "cart"],
            sortable: true,

            columns: {
                operation1: { className: "mw-120 max-w-150 hidden1000" },
                operation2: {
                    className: "mw-120 hidden1300 max-w-140",
                },
                operationOut2: {
                    className: "mw-120 hidden1300 max-w-140",
                },
                cart: {
                    className: "mw-120 hidden1300  max-w-150",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "endCustomer.name") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "endCustomer.name")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.inquiryNumber.labelInquiry"),
            field: "inquiryNumber",
            tables: [...operation1Types, "cart"],
            sortable: true,
            className: "mw-120 max-w-150 hidden1700",
            columns: {
                operation1: {},
                cart: {
                    className: "mw-120 hidden1700 max-w-150",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "inquiryNumber") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "inquiryNumber")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.inquiryNumber.labelOrder"),
            field: "inquiryNumber",
            tables: allOperation2Types,
            sortable: true,
            columns: {
                operation2: {
                    className: "mw-100 hidden940",
                },
                operationOut2: {
                    className: "mw-100 hidden940",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.constructionProject.label"),
            field: "constructionProject",
            tables: allTableColumnTypes,
            sortable: true,
            columns: {
                operation1: {
                    className: "mw-120 hidden2000",
                },
                operation2: {
                    className: "mw-120 hidden1150",
                },
                operationOut2: {
                    className: "mw-120 hidden1150",
                },
                operationOut1: {
                    className: "mw-120 hidden800",
                },
                cart: {
                    className: "mw-120 hidden800",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "constructionProject") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "constructionProject")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.commission.label"),
            field: "commission",
            tables: allTableColumnTypes,
            sortable: true,
            columns: {
                operation1: {
                    className: "mw-120 hidden860",
                },
                operation2: {
                    className: "mw-120 hidden1100",
                },
                operationOut2: {
                    className: "mw-120 hidden1100",
                },
                operationOut1: {
                    className: "mw-120 hidden920",
                },
                cart: {
                    className: "mw-120 max-w-150 hidden720",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "commission") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "commission")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.constructionSite.label"),
            field: "constructionSite",
            tables: [...operation1Types, ...allOperation2Types, "cart"],
            sortable: true,
            columns: {
                operation1: {
                    className: "mw-120 hidden1400",
                },
                operation2: {
                    className: "mw-100 hidden1800 max-w-120",
                },
                operationOut2: {
                    className: "mw-100 hidden1800 max-w-120",
                },
                operationOut1: {
                    className: "mw-120 hidden1900",
                },
                cart: {
                    className: "mw-120 hidden1900",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "constructionSite") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "constructionSite")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.inquiryContact.label"),
            field: "inquiryContact.name",
            sortable: true,
            tables: [...allOperation1Types, "cart"],
            columns: {
                operation1: {
                    className: "mw-120 hidden1900",
                },
                operationOut1: {
                    className: "mw-120 hidden1900",
                },
                cart: {
                    className: "mw-120 hidden1900",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${filterValueUpdates(op, "inquiryContact.name") || "invalid"}`,
                            optional: true,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "inquiryContact.name")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.lastUpdatedBy.label"),
            field: "lastUpdatedBy.name",
            sortable: true,
            tables: ["operationOut1"],
            getTooltipProps(op: Operation, field) {
                return {
                    value: `${filterValueUpdates(op, "lastUpdatedBy.name") || "invalid"}`,
                    optional: true,
                }
            },
            columns: {
                operationOut1: {
                    className: "mw-150 hidden1900",
                },
            },
        },

        {
            label: svelteGet(_)("tableColumns.deliveryAddress.label"),
            field: "deliveryAddress.city",
            tables: allOperation2Types,
            sortable: true,
            tooltipComponent: TextField,
            columns: {
                operation2: {
                    className: "w-100 hidden1700 ovf_ellipse",
                    getTooltipProps(op: Operation, field) {
                        const d = op.deliveryAddress
                        if (d) {
                            let addr = d.name1 || "invalid"
                            if (d.name2) addr += "\n  " + d.name2
                            if (d.name3) addr += "\n  " + d.name3
                            addr += "\n" + (d.street || "invalid")
                            addr += "\n" + (d.postcode || "invalid") + (d.city || "invalid")
                            if (d.country) addr += "\n" + d.country
                            return {
                                value: addr,
                                style: "display: block; text-align:left; white-space: pre-wrap",
                            }
                        }
                        return {
                            value: svelteGet(_)("tableColumns.deliveryAddress.noDeliveryAddress"),
                        }
                    },
                },
                operationOut2: {
                    className: "w-100 hidden1700 ovf_ellipse",
                    getTooltipProps(op: Operation, field) {
                        const d = op.deliveryAddress
                        if (d) {
                            let addr = d.name1 || "invalid"
                            if (d.name2) addr += "\n  " + d.name2
                            if (d.name3) addr += "\n  " + d.name3
                            addr += "\n" + (d.street || "invalid")
                            addr += "\n" + (d.postcode || "invalid") + (d.city || "invalid")
                            if (d.country) addr += "\n" + d.country
                            return {
                                value: addr,
                                style: "display: block; text-align:left; white-space: pre-wrap",
                            }
                        }
                        return {
                            value: svelteGet(_)("tableColumns.deliveryAddress.noDeliveryAddress"),
                        }
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.endCustomerFullAddress.label"),
            field: "endCustomerFullAddress",
            component: EndCustomerName,
            getProps(row, field) {
                return {
                    address: get(row, field),
                }
            },
            sortable: true,
            className: "mw-120 hidden1300",
            tables: ["operationOut1"],
            columns: {},
        },
        {
            label: svelteGet(_)("tableColumns.endCustomerFullAddress.address"),
            field: "endCustomerAddress.city",
            tables: ["operationOut1"],
            sortable: true,

            tooltipComponent: TextField,
            columns: {
                operationOut1: {
                    className: "w-100 hidden1700 ovf_ellipse",
                    getTooltipProps(op: OperationOut, field) {
                        const d = op.endCustomerAddress
                        let address = op.endCustomerFullAddress
                        if (address) {
                            let addr = ""
                            if (address.type == "person") {
                                addr +=
                                    address.person.salutation +
                                    " " +
                                    address.person.firstname +
                                    " " +
                                    address.person.lastname
                            } else {
                                addr += address.company.name
                            }
                            addr += "\n" + (address.location.street || "")
                            addr += "\n" + (address.location.postcode || "") + (address.location.city || "")
                            if (address.location.country) addr += "\n" + address.location.country

                            return {
                                value: addr,
                                style: "display: block; text-align:left; white-space: pre-wrap",
                            }
                        } else if (d) {
                            let addr = d.name1 || ""
                            if (d.name2) addr += "\n  " + d.name2
                            if (d.name3) addr += "\n  " + d.name3
                            addr += "\n" + (d.street || "")
                            addr += "\n" + (d.postcode || "") + (d.city || "")
                            if (d.country) addr += "\n" + d.country
                            return {
                                value: addr,
                                style: "display: block; text-align:left; white-space: pre-wrap",
                            }
                        } else
                            return {
                                value: "keine Lieferadresse",
                            }
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.residentialUnitsCount.label"),
            field: "residentialUnitsCount",
            tables: allTableColumnTypes,
            sortable: true,
            getTooltipProps(op: Operation, field) {
                return {
                    value:
                        op.residentialUnitsCount + " " + svelteGet(_)("components.operationsFilter.residentialUnits"),
                }
            },

            align: "center",
            tooltipComponent: TextField,
            headerTooltip: svelteGet(_)("components.operationsFilter.residentialUnits"),
            columns: {
                operation1: {
                    className: "mw-60 w-60 max-w-60 ",
                },
                operation2: {
                    className: "mw-60 w-60 hidden1550 max-w-60",
                },
                operationOut2: {
                    className: "mw-60 w-60 hidden1550 max-w-60",
                },
                operationOut1: {
                    className: "mw-60 max-w-60 w-60 hidden860",
                },
                cart: {
                    className: "mw-60 w-60 hidden860  max-w-60",
                    tooltipComponent: TextField,
                    getTooltipProps(op: Operation, field) {
                        return {
                            value: `${op.residentialUnitsCount} ${svelteGet(_)("positions.residentialUnits")}  <br /> ${
                                filterValueUpdates(op, `residentialUnitsCount`) || ""
                            }`,
                        }
                    },
                    getClasses(op) {
                        return hasValueUpdates(op, "residentialUnitsCount")
                    },
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.sumNetPrice.label"),
            field: "sumNetPrice",
            tables: [...allOperation1Types, ...allOperation2Types],
            sortable: true,
            align: "right",
            tooltipComponent: OperationPositionPriceSummary,
            component: NumberField,
            getProps(row, field) {
                return {
                    value: get(row, field),
                    unit: "€",
                }
            },
            getTooltipProps(row, field) {
                return {
                    tableRow: row,
                }
            },
            hide: !_showPrices,
            columns: {
                operation1: {
                    className: "mw-100 w-100 max-w-100 hidden1200",
                },
                operation2: {
                    className: "mw-100 w-100 max-w-140 hidden780",
                },
                operationOut2: {
                    className: "mw-100 w-100 max-w-140 hidden780",
                },
                operationOut1: {
                    className: "mw-100 w-100 max-w-120 hidden700",
                },
            },
        },
        {
            label: svelteGet(_)("tableColumns.followUpListOwner.label"),
            tables: ["operationOut1Bookmarks", "operationOut2Bookmarks", "operation1Bookmarks", "operation2Bookmarks"],
            className: "mw-140 w-140 ",
            component: FollowUpListOwner,
            getProps(op: FollowUpOperation | FollowUpOperationOut, field) {
                return {
                    account: op.attachedAccount,
                }
            },
            columns: {},
        },
        {
            label: svelteGet(_)("tableColumns.description.label"),
            tables: ["accountToken"],
            className: " w-140 ",
            field: "description",
            columns: {},
            sortable: false,
        },
        {
            label: svelteGet(_)("tableColumns.insertTime.label"),
            tables: ["accountToken"],
            className: "mw-70 w-70 ",
            field: "insertTime",
            component: DateTimeField,
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {},
            sortable: false,
        },
        {
            label: svelteGet(_)("tableColumns.lastUsed.label"),
            tables: ["accountToken"],
            className: "mw-70 w-70 ",
            field: "lastUsed",
            component: DateTimeField,
            getProps(row, field) {
                return {
                    value: get(row, field),
                }
            },
            columns: {},
            sortable: false,
        },
        ...additionalColumns,
    ]

    let returnedTable: AllTableColumns[] = []
    allTableColumns.forEach((tableColumn) => {
        let tableColumnCopy = { ...tableColumn }
        if (tableColumn.tables.includes(operationtype)) {
            if (tableColumnCopy.columns[operationtype]) {
                tableColumnCopy = { ...tableColumnCopy, ...tableColumnCopy.columns[operationtype] }
            }
            returnedTable.push(tableColumnCopy)
        }
    })
    return returnedTable
}
function filterValueUpdates(operation: Operation, path: string) {
    let logs = operation?.updateLogs
    if (!logs) return
    let valueUpdates = logs.filter((obj) => obj?.field == path)
    let finalString = ""
    const getPrevious = (previous: any) => {
        if (previous == "null") return "Kein früherer Eintrag"
        if (previous == "true") return "Ja"
        if (previous == "false") return "Nein"
        return previous
    }
    valueUpdates.forEach((o) => {
        finalString += `<strong style="">früherer Wert:</strong> ${getPrevious(o?.previous)} <br/>`
    })
    return finalString
}

function hasValueUpdates(operation: Operation, path: string) {
    let logs = operation?.updateLogs
    if (!logs) return
    let valueUpdates = logs.filter((obj) => obj?.field == path)
    return valueUpdates.length > 0 ? "marked" : ""
}
/*
    async function deselectPositionFromOperation(position: OperationPosition, operation) {
        operation.positions.forEach((pos) => {
            if (JSON.stringify(pos) == JSON.stringify(position)) {
                if (pos.orderQuantity > 0) pos.quantity = pos.orderQuantity
                pos.orderQuantity = 0
            }
        })
        deletePositionOperation = null
        if (cart && !inCart) updateCartDebounce(cartObj)
        dispatch("positionSeletion", { operation })
    }
*/
